import React from 'react';
import { white } from '../../Styles/Colours';
import { Button } from '../Button';
import { LoadingErrorIcon, ReloadIcon } from '../Icons';
import styles from './LoadingError.module.css';
export function LoadingError(_a) {
    var message = _a.message, info = _a.info;
    var reload = function () {
        window.location.reload();
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement(LoadingErrorIcon, null),
        React.createElement("div", { className: styles.bodyText }, message !== null && message !== void 0 ? message : 'Whoops... we’ve run into an error'),
        React.createElement("div", { className: styles.info }, info !== null && info !== void 0 ? info : 'Please reload the page to try fetch the data you need.'),
        React.createElement(Button, { testId: 'error-action', onClick: reload, startIcon: React.createElement(ReloadIcon, { color: white, size: '24', noPadding: true }) }, "Reload")));
}
